import React, { Component } from 'react';
import Constants from '../../Config/Config';
import Parser from 'html-react-parser';

class MiddleMat extends Component {
  	render() {
  		const {middleMatTotal, selectedMiddleMat, selectedMatSize} = this.props;
	    return (
	        <tr>
				<th>Middle Mat</th>
				<td>{selectedMiddleMat.getIn(['title', 'rendered']) !== undefined && parseFloat(selectedMatSize) === 2 ? Parser(selectedMiddleMat.getIn(['title', 'rendered'])) : "None Selected"}</td>
				<td>{Constants.Currency}{parseFloat(selectedMatSize) === 2 ? middleMatTotal : '0'}</td>
            </tr>
	    );
  	}
}

export default MiddleMat;